import { Flex } from '@oliasoft-open-source/react-ui-library';
import { IObject } from 'common/interfaces/hierarchy-entities';
import { useCallback, useEffect, useState } from 'react';
import { getObjectBlobUrl } from '../utils/export';

interface IImageViewerProps {
  dataObject: IObject
}

export const ImageViewer = ({ dataObject }: IImageViewerProps) => {
  const [imageUrl, setImageUrl] = useState<string>();
  
  const getImageUrl = useCallback(async () => {
    const url = await getObjectBlobUrl(dataObject!);
    setImageUrl(url);
  }, [dataObject]);

  useEffect(() => {
    getImageUrl().catch(console.error);
  }, [dataObject]);

  return (
    <Flex justifyContent="center">
      <img src={imageUrl} alt="file" style={{ width: '100%' }} />
    </Flex>
  );
};